type AppCfg = {
  BASE_URL: string;
  DESTINE_GW_URL:string;
  KEYCLOAK_URL: string;
  REALM: string;
  CLIENT_ID: string;
};

function cfg(): AppCfg {
  const c = (window as any).APP_CONFIG;
  if (!c) throw new Error('APP_CONFIG not found. Ensure app-config.js loads before main.*.js');
  return c as AppCfg;
}

export const environment = {
  get baseUrl()    { return cfg().BASE_URL; },
  get destineGwUrl()    { return cfg().DESTINE_GW_URL; },
  get keycloakUrl(){ return cfg().KEYCLOAK_URL; },
  get realm()      { return cfg().REALM; },
  get clientId()   { return cfg().CLIENT_ID; },
};